import { Env, readFromEnv } from '@cinch-nx/environments'

/**
 * Reads the `qs` provenance signature that the IRS client API attaches alongside `q`.
 *
 * The value is an HMAC-SHA256 digest of `q`, so it is returned exactly as it appears in the
 * URL — no trimming, casing or re-encoding. A single changed byte makes the signature fail
 * verification, and the backend silently drops `q` rather than reporting an error.
 */
export const getNaturalLanguageQuerySignatureFromUrlPath = (
  urlPath: string,
  isAiSearchVariant = false,
): string | null => {
  const isNaturalLanguageSearchEnabled =
    readFromEnv(Env.EnableNaturalLanguageSearch) === 'true' && isAiSearchVariant

  if (!isNaturalLanguageSearchEnabled) {
    return null
  }

  const urlWithoutLeadingSlash = urlPath.startsWith('/')
    ? urlPath.slice(1)
    : urlPath

  return new URLSearchParams(urlWithoutLeadingSlash.split('?')[1]).get('qs')
}
